import React, { useEffect, useState } from "react";
import {
  hasIdledOut,
  markActivity,
  startIdleWatcher
} from "../../framework/src/session/IdleWatcher.web";
import { expireSession } from "../../framework/src/session/expireSession.web";

// Wraps the authenticated area: signs the user out after the configured
// inactivity window and drops them straight on the login screen.
const SessionGuard: React.FC = ({ children }) => {
  const [idled] = useState(hasIdledOut);

  useEffect(() => {
    if (idled) {
      expireSession();
      return;
    }

    markActivity();

    return startIdleWatcher(expireSession);
  }, [idled]);

  // Rendering the children of an already expired session would fire API calls
  // with a dead token and flash the dashboard before the redirect.
  return idled ? null : <>{children}</>;
};

export default SessionGuard;
